

export enum BaseEntityStatuses {
    DELETED = -1,
    ACTIVE_NOT_ARCHIVED = 0,
    ACTIVE_AND_ARCHIVED = 1,
}
